import _ from 'lodash'
import ChartAccessoryWidgetView from 'scoreboard/dashboards/widgets/chart/chart-accessory-widget-view'
import template from './chart-table-widget-view.hbs'
import ChartDataTable from 'scoreboard/charts/chart-data-table'
import togglePrefixedClass from 'scoreboard/components/toggle-prefixed-class'

const SHOW_PROPERTIES = ['showData', 'showSeriesColor', 'showSeriesLabel']

const ChartTableView = ChartAccessoryWidgetView.extend({
	className: 'widget chart-table',

	/**
	 * @type {ChartTableModel}
	 */
	model: null,

	accessoryTemplate: template,

	nonFetchProperties: ChartAccessoryWidgetView.prototype.nonFetchProperties
		.concat(SHOW_PROPERTIES),

	initialize: function (opt) {
		ChartAccessoryWidgetView.prototype.initialize.apply(this, arguments)

		// When the canvas is ready, call resize() again in order to make sure
		// the overflow classes are applied correctly.
		this.listenTo(this.canvas, 'ready', () => this.resize())

		SHOW_PROPERTIES.forEach(prop => {
			this.listenTo(this.model.properties, 'change:' + prop, () => this.renderContent())
		})

		let chartWob = this._findChartWob()
		this.listenTo(chartWob.widget.properties, 'change:tableFontSize', () => {
			this.render()
		})
	},

	render: function () {
		ChartAccessoryWidgetView.prototype.render.apply(this, arguments)
		let chartWob = this._findChartWob()
		let fontSize = chartWob.widget.properties.get('tableFontSize')
		togglePrefixedClass(this.el, 'font-size', fontSize)
		return this
	},

	/**
	 * @override
	 */
	renderContent () {
		let chartWob = this._findChartWob()
		let chart = chartWob.widget.chart

		if (chart.get('error')) {
			this.renderError()
			return
		}

		this.showContent(true)

		let tableOptions = _.extend(
			this.model.properties.pick(SHOW_PROPERTIES),
			{ model: chart, widgetModel: this.model })

		this.dataTable = new ChartDataTable(tableOptions)

		this.$('.panel-content').empty().append(this.dataTable.el)
		this.dataTable.render()

		this.toggleLoading(false)
		this.fitWobToContent(this.firstRender)
		this.firstRender = false
	},

	/**
	 * @override
	 */
	getWidgetContent: function() {
		return this.$('.table')[0]
	},

	/**
	 * @override
	 */
	defaultFit: function() {
		return { height: true }
	},

	/**
	 * @override
	 */
	resize: function() {
		this.$el.removeClass('is-overflowing-x is-overflowing-y')
		// We can test here on resize to see if the widget is overflowing vertically.
		// This class will tell us whether or not to show the bottom table border.
		// We can use is-overflowing-x in displaying borders in exported dashbords
		let overflowY = this.isOverflowingY(this.$('.panel'))
		let overflowX = this.isOverflowingX(this.$('.panel-content'))
		this.$el.toggleClass('is-overflowing-y', overflowY)
		this.$el.toggleClass('is-overflowing-x', overflowX)
	},

	/**
	 * @override
	 */
	removeFromChartWidget: function() {
		var chartWob = this._findChartWob()
		if (chartWob && chartWob.widget.chart.get('chartTable')) {
			// #10237 If this table wob was destroyed, but chartTable is still true,
			// set it to false quietly (so it stays as a single undo/redo record)
			this.canvas.history.quietly(function () {
				chartWob.widget.chart.set('chartTable', false)
			})
		}
	},

	/**
	 * @override
	 */
	isDrilldownExcluded: function(evtEl) {
		// A click on anything other than the serie name cell should do the
		// configured widget-level drilldown; logic for clicking on a serie
		// name is in ChartDataTable.onClickSerie()
		return this.elIsOrIsDescendantOfSelector(evtEl, 'td.object')
	},

	remove: function () {
		ChartAccessoryWidgetView.prototype.remove.apply(this, arguments)
		_.invokeMap([this.dataTable], 'remove')
	}
})

export default ChartTableView
ChartTableView.__filename__ = 'dashboards/widgets/chart/chart-table-widget-view.js'
